import { IWebsiteSetting, IWebsiteSettingDetail } from '@/customTypings/common/WebsiteSetting';
import type { UnchangedUpdateResponse } from '@/utils/api/updateResponse';
import { authHeader, handleResponse } from '../../utils';
import { appendIncludeAuditQuery, type DetailGetByIdOptions } from '@/utils/api/detailGetOptions';

export const websiteSettingService = {
    get,
    edit,
    getAll,
};

function get(id: string, options?: DetailGetByIdOptions) {
    const requestOptions: RequestInit = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(
        appendIncludeAuditQuery(`/api/websitesetting/get?id=${encodeURIComponent(id)}`, options),
        requestOptions
    )
        .then(handleResponse)
        .then((response): IWebsiteSettingDetail => {
           return response;
        });
}

function edit(websiteSetting: IWebsiteSetting): Promise<void | UnchangedUpdateResponse> {
    const requestOptions: RequestInit = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(websiteSetting),
    };
    return fetch(`/api/websitesetting/edit`, requestOptions).then(
        handleResponse
    ) as Promise<void | UnchangedUpdateResponse>;
}

function getAll() {
    const requestOptions: RequestInit = {
        method: 'GET',
        headers: authHeader(),
        credentials: "include"
    };
    return fetch(`/api/websitesetting/getall`, requestOptions)
        .then(handleResponse);
}
